import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";
import minMax from "dayjs/plugin/minMax";
import { Typography } from "antd";
import { useEffect, useMemo, useState } from "react";
import { Button, Popup } from "antd-mobile";

const dayOfWeek = (date) => (date.day() - 1 + 7) % 7;

const MonthView = ({ minDate, month, selectedDates, onClick }) => {
    const startDayOfWeek = dayOfWeek(month);
    const getOffset = (r, c) => r * 7 + c - startDayOfWeek;
    const daysOfWeek = [...Array(7).keys()];
    const weeks = Math.ceil((month.daysInMonth() + startDayOfWeek) / 7);
    const rows = [...Array(weeks).keys()];
    const header = ["L", "M", "M", "G", "V", "S", "D"];
    const monthYearStr = month.format("YYYY-MM");

    return (
        <table style={{ borderCollapse: "separate", borderSpacing: "0px 4px", width: "100%" }}>
            <thead>
                <tr>
                    {header.map((x, idx) => (
                        <th key={`dow_${idx}`}>{x}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row) => (
                    <tr key={`${monthYearStr}-${row}`}>
                        {daysOfWeek.map((col) => {
                            const offset = getOffset(row, col);
                            const date = month.add(offset, "day");
                            const dateStr = date.format("YYYY-MM-DD");
                            const sameMonth = date.month() === month.month();
                            const isAfterMinDate = date.isSameOrAfter(minDate);
                            const value =
                                offset >= 0 && isAfterMinDate ? (sameMonth ? date.date() : "") : "";
                            const highlight =
                                sameMonth &&
                                isAfterMinDate &&
                                selectedDates.some((x) => x === dateStr)
                                    ? { background: "blue", color: "white" }
                                    : {};
                            return (
                                <td
                                    key={`${monthYearStr}-${row}-${col}`}
                                    onClick={() =>
                                        sameMonth &&
                                        isAfterMinDate &&
                                        onClick?.(date.format("YYYY-MM-DD"))
                                    }
                                    style={{
                                        cursor: sameMonth && isAfterMinDate ? "pointer" : "inherit",
                                        textAlign: "center",
                                        padding: 10,
                                        ...highlight,
                                    }}
                                >
                                    {value}
                                </td>
                            );
                        })}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

const MyCalendar = ({ minDate, selectedDates, onClick }) => {
    const months = [...Array(12).keys()].map((x) => dayjs().startOf("month").add(x, "month"));
    return (
        <>
            {months.map((x) => (
                <div key={x.format("YYYY-MM")}>
                    <Typography.Title level={5}>{x.format("MMMM YYYY")}</Typography.Title>
                    <MonthView
                        minDate={dayjs(minDate)}
                        month={x}
                        selectedDates={selectedDates ?? []}
                        onClick={onClick}
                    />
                </div>
            ))}
        </>
    );
};

const getDates = (range) => {
    const start = dayjs.min(range[0], range[1]);
    const end = dayjs.max(range[0], range[1]);
    const days = Array.from({ length: end.diff(start, "day") - 1 }, (_, i) => i + 1).map((i) =>
        start.add(i, "day"),
    );
    return days;
};

export default function ({ onMaskClick, minDate, visible, onClose, onChange, value, type }) {
    dayjs.extend(weekOfYear);
    dayjs.extend(minMax);
    const [range, setRange] = useState([]);

    const selectedDates = useMemo(() => {
        const dayjsRange = range.map((x) => dayjs(x));
        const days = dayjsRange;
        const rest = dayjsRange.length == 2 ? getDates(dayjsRange) : [];

        return days.concat(rest).map((x) => x.format("YYYY-MM-DD"));
    }, [range]);

    useEffect(() => {
        setRange(value ?? []);
    }, [value, visible]);

    const set = (date) => {
        if (type === "multi") {
            range.length === 0 || range.length === 2
                ? setRange([date])
                : setRange([...new Set([...range, date])].sort());
        } else {
            setRange([date]);
        }
    };

    return (
        <>
            <Popup onMaskClick={onMaskClick} visible={visible} showCloseButton onClose={onClose}>
                <div style={{ height: "80vh", display: "flex", flexDirection: "column" }}>
                    <div
                        style={{
                            paddingLeft: 10,
                            paddingBottom: 10,
                            borderBottom: "1px solid gray",
                        }}
                    >
                        <h2
                            style={{
                                padding: 0,
                            }}
                        >
                            Seleziona le date
                        </h2>
                    </div>
                    <div
                        style={{
                            flex: 1,
                            overflow: "auto",
                            msOverflowStyle: "none",
                            scrollbarWidth: "none",
                            padding: "0px 10px",
                        }}
                    >
                        <MyCalendar minDate={minDate} selectedDates={selectedDates} onClick={set} />
                    </div>

                    <div
                        style={{
                            borderTop: "1px solid gray",
                            display: "flex",
                            flexDirection: "row",
                            placeItems: "center",
                            padding: 10,
                        }}
                    >
                        <div style={{ flex: 1 }}>
                            {range.length === 2 &&
                                `Dal ${dayjs(range[0]).format("DD/MM/YYYY")} al ${dayjs(range[1]).format("DD/MM/YYYY")}`}
                        </div>
                        <Button
                            type="submit"
                            color="primary"
                            disabled={type === "multi" ? range.length !== 2 : range.length !== 1}
                            onClick={() => onChange(range)}
                        >
                            Conferma
                        </Button>
                    </div>
                </div>
            </Popup>
        </>
    );
}
